import actions from './actions';
import { configOperations } from '../config';

const {
  setCurrentIncident,
  setCurrentIncidentStats,
  setIncidentFields,
  setIncidentHistoryFields,
  setIncident209ResourcesFields,
  clearCurrentIncident,
  setInitialIncidentFilter,
  updateIncidentFilterValues,
  updateIncidentSqlFilter,
  clearIncidentFilters,
  setHistoryLoading,
  setHistoryIncidents,
  setHistoryIsMore,
  setHistoryIncidentCount,
  setHistoryShowDataGrid
} = actions;

const setInitialIncidentListColumns = columnNames => (dispatch, getState) => {
  // used to initially set columns for a user or
  // at a later time reset them to a configured default array of column names
  dispatch(actions.setInitialIncidentListColumns(columnNames));

  dispatch(
    configOperations.setIncidentListColumns(
      getState().incident.incidentListColumns
    )
  );
};

const addIncidentListColumn = (columnName, indexPosition) => (
  dispatch,
  getState
) => {
  dispatch(actions.addIncidentListColumn(columnName, indexPosition));

  dispatch(
    configOperations.setIncidentListColumns(
      getState().incident.incidentListColumns
    )
  );
};

const removeIncidentListColumn = (columnName, indexPosition) => (
  dispatch,
  getState
) => {
  dispatch(actions.removeIncidentListColumn(columnName, indexPosition));

  dispatch(
    configOperations.setIncidentListColumns(
      getState().incident.incidentListColumns
    )
  );
};

const setInitialIncidentResourceListColumns = columnNames => (
  dispatch,
  getState
) => {
  dispatch(actions.setInitialIncidentResourceListColumns(columnNames));
  dispatch(
    configOperations.setIncidentResourceListColumns(
      getState().incident.incidentResourceListColumns
    )
  );
};

const addIncidentResourceListColumn = (columnName, indexPosition) => (
  dispatch,
  getState
) => {
  dispatch(actions.addIncidentResourceListColumn(columnName, indexPosition));
  dispatch(
    configOperations.setIncidentResourceListColumns(
      getState().incident.incidentResourceListColumns
    )
  );
};

const removeIncidentResourceListColumn = (columnName, indexPosition) => (
  dispatch,
  getState
) => {
  dispatch(actions.removeIncidentResourceListColumn(columnName, indexPosition));
  dispatch(
    configOperations.setIncidentResourceListColumns(
      getState().incident.incidentResourceListColumns
    )
  );
};

const setInitialIncidentRequestListColumns = columnNames => (
  dispatch,
  getState
) => {
  dispatch(actions.setInitialIncidentRequestListColumns(columnNames));
  dispatch(
    configOperations.setIncidentRequestListColumns(
      getState().incident.incidentRequestListColumns
    )
  );
};

const addIncidentRequestListColumn = (columnName, indexPosition) => (
  dispatch,
  getState
) => {
  dispatch(actions.addIncidentRequestListColumn(columnName, indexPosition));
  dispatch(
    configOperations.setIncidentRequestListColumns(
      getState().incident.incidentRequestListColumns
    )
  );
};

const removeIncidentRequestListColumn = (columnName, indexPosition) => (
  dispatch,
  getState
) => {
  dispatch(actions.removeIncidentRequestListColumn(columnName, indexPosition));
  dispatch(
    configOperations.setIncidentRequestListColumns(
      getState().incident.incidentRequestListColumns
    )
  );
};

const setInitialIncidentExperienceListColumns = columnNames => (
  dispatch,
  getState
) => {
  dispatch(actions.setInitialIncidentExperienceListColumns(columnNames));
  dispatch(
    configOperations.setIncidentExperienceListColumns(
      getState().incident.incidentExperienceListColumns
    )
  );
};

const addIncidentExperienceListColumn = (columnName, indexPosition) => (
  dispatch,
  getState
) => {
  dispatch(actions.addIncidentExperienceListColumn(columnName, indexPosition));
  dispatch(
    configOperations.setIncidentExperienceListColumns(
      getState().incident.incidentExperienceListColumns
    )
  );
};

const removeIncidentExperienceListColumn = (columnName, indexPosition) => (
  dispatch,
  getState
) => {
  dispatch(
    actions.removeIncidentExperienceListColumn(columnName, indexPosition)
  );
  dispatch(
    configOperations.setIncidentExperienceListColumns(
      getState().incident.incidentExperienceListColumns
    )
  );
};

export default {
  setCurrentIncident,
  setCurrentIncidentStats,
  setIncidentFields,
  setIncidentHistoryFields,
  setIncident209ResourcesFields,
  clearCurrentIncident,
  setInitialIncidentFilter,
  updateIncidentFilterValues,
  updateIncidentSqlFilter,
  clearIncidentFilters,
  setInitialIncidentListColumns,
  addIncidentListColumn,
  removeIncidentListColumn,
  setInitialIncidentResourceListColumns,
  addIncidentResourceListColumn,
  removeIncidentResourceListColumn,
  setInitialIncidentRequestListColumns,
  addIncidentRequestListColumn,
  removeIncidentRequestListColumn,
  setInitialIncidentExperienceListColumns,
  addIncidentExperienceListColumn,
  removeIncidentExperienceListColumn,
  setHistoryLoading,
  setHistoryIncidents,
  setHistoryIsMore,
  setHistoryIncidentCount,
  setHistoryShowDataGrid
};



// WEBPACK FOOTER //
// ./src/redux/incident/operations.js